export const workdetailsReducer = (state = "", action) => {
  switch (action.type) {
    case "SET_WORKDETAILS":
      return action.payload;
    default:
      return state;
  }
};
